export default __webpack_public_path__ + "static/media/green_3.bce6f3a1.png";